// extracted by mini-css-extract-plugin
module.exports = {"SwiperOnlyH5":"SwiperOnlyH5_SwiperOnlyH5__hJv49"};